import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Reveal, Overline } from "./Reveal";

const FAQS = [
  {
    q: "When does the course start and finish?",
    a: "Dates for the upcoming cohort are to be confirmed. Sessions run live at 10pm SGT / 4pm CEST / 10am EST. There will be short breaks during major holiday seasons or when Diego travels.",
  },
  {
    q: "How can I access the coach if I have doubts?",
    a: "You'll have a dedicated WhatsApp group for Q&A and guidance, plus a single point of contact through WhatsApp messaging or call whenever you need support between sessions.",
  },
  {
    q: "What does the 1:1 curriculum look like?",
    a: "Before session 10 you can choose to upgrade to a personalised 1:1 journey. You'll consult with Diego in advance to tailor the pace, schedule and focus areas to your goals.",
  },
  {
    q: "Are sessions recorded?",
    a: "Yes. All sessions are conducted live via Zoom and full recordings are provided — it's highly recommended to revisit each class afterwards.",
  },
  {
    q: "What do I need for each session?",
    a: "A stable internet connection and your camera ON. As a backup, prepare a second device (laptop or phone) for a voice connection or hotspot.",
  },
];

export default function Faq() {
  return (
    <section id="faq" data-testid="faq-section" className="relative py-28 md:py-40">
      <div className="max-w-4xl mx-auto px-6">
        <Reveal className="mb-14">
          <Overline>FAQ</Overline>
          <h2 className="font-display text-4xl md:text-6xl tracking-tight leading-tight text-white mt-5">
            Questions, answered.
          </h2>
        </Reveal>

        <Reveal delay={0.1}>
          <Accordion type="single" collapsible className="w-full">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                data-testid={`faq-item-${i}`}
                className="border-b border-white/10"
              >
                <AccordionTrigger className="text-left font-body text-lg md:text-xl text-white hover:text-burgundy hover:no-underline py-6">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-slate-400 text-base leading-relaxed pb-6">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>
      </div>
    </section>
  );
}
